import { Provider } from '@angular/core';
import { ResponsiveWindowDirective } from './responsive-window';
export const RESPONSIVEWINDOW_DIRECTIVE: Provider[] = [ ResponsiveWindowDirective ];
export * from './responsive-window';
